import Tooltip from "@mui/material/Tooltip";

const SecondaryTeamCard = ({ photo, name, hoverContents }) => {
  return (
    <div className="flex flex-col items-center">
      <div className="w-40 md:w-48 h-40 md:h-48 bg-grey rounded-full mb-4">
        {photo}
      </div>
      <Tooltip title={hoverContents}>
        <div className="flex items-center justify-center w-72 h-14 bg-orange/60 rounded-full cursor-pointer">
          <h2 className="text-xl">{name}</h2>
        </div>
      </Tooltip>
    </div>
  );
};

export default SecondaryTeamCard;
